<template>
	<div>
		<div class="container">
			<div class="packages-content">
				<BlockCategoryDropdown v-on:searchCat="cat($event)" withSearch type='package' />
				<BlockSearchBox type='package'/>
			</div>
			<BlockItemListing type='package' />
		</div>
	</div>
</template>

<script>
	import BlockCategoryDropdown from './BlockCategoryDropdown.vue';
	import BlockItemListing from './BlockItemListing.vue';
	import BlockSearchBox from './BlockSearchBox.vue';

	export default {
		components: {
			BlockItemListing,
			BlockCategoryDropdown,
			BlockSearchBox
		}
	};
</script>
<style>

</style>
